import { Controller } from "@hotwired/stimulus"

// Generic segmented control (a row of .chip buttons acting like radios) that
// writes the selected value into a hidden field — used by the book form's
// "Condição" control.
export default class extends Controller {
  static targets = ["chip", "input"]

  select(event) {
    const value = event.currentTarget.dataset.value
    this.inputTarget.value = value
    this.chipTargets.forEach((chip) => chip.classList.toggle("active", chip.dataset.value === value))
  }
}
